import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input, TextArea, Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";

import { CardAtividade, Container } from "./styles";
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from "~/services/api";

function AtividadesList({ defaultData, setter, setterSoma, gerarProjeto, disabled }) {
  const atividadePad = [
    { item: 1, id: 0, titulo: "Levantamento de Requisitos", descricao: "", horaTotal: 0, horaSaldo: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", analistas: [] },
    { item: 2, id: 0, titulo: "Desenvolvimento", descricao: "", horaTotal: 0, horaSaldo: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", analistas: [] },
    { item: 3, id: 0, titulo: "Homologação e Correções dentro do Escopo", descricao: "", horaTotal: 0, horaSaldo: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", analistas: [] },
    { item: 4, id: 0, titulo: "Aplicação em Produção e Acompanhamento", descricao: "", horaTotal: 0, horaSaldo: 0, dataInicioProjeto: "", dataPrevEntregaProjeto: "", analistas: [] }
  ];
  const [atividades, setAtividades] = useState([]);
  const [analistas, setAnalistas] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/gerencia/analistas", { params: { ativo: 1 } }).then((r) => setAnalistas(r?.data));
  }, []);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aAtividade = [];
          let item = 1;
          for (const itemAtividade of defaultData) {
            aAtividade.push({ item, ...itemAtividade });

            item++;
          }
          setAtividades(aAtividade);
          setter(aAtividade);
        }
      } else {
        if (!(edit && editShow)) {
          setAtividades(atividadePad);
          setter(atividadePad);
        }
      }
    }
  }, [edit, editShow]);

  useEffect(() => {
    setter(atividades);

    if (setterSoma) {
      let horaTotal = 0;
      for (const item of atividades) {
        horaTotal += item?.horaTotal;
      }

      setterSoma(horaTotal);
    }
  }, [atividades]);

  function handleAddAtividade() {
    setAtividades((prev) => [
      ...prev,
      {
        item: (atividades?.length > 0 ? atividades[atividades?.length - 1]?.item + 1 : 1),
        id: 0,
        titulo: "Atividade de Orçamento",
        descricao: "",
        horaTotal: 0,
        horaSaldo: 0,
        dataInicioProjeto: "",
        dataPrevEntregaProjeto: "",
        analistas: []
      }
    ]);
  }

  function handleRemoveAtividade(data) {
    setAtividades((prev) => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex((e) => e?.item === data?.item);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Atividades *" className="titulo-label" row={true}>
        {!(editShow && edit) && !disabled ? (
          <ColoredButton small blueLayout type="button" onClick={handleAddAtividade}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )}
      </Label>
      {atividades?.map((itemData, index) => (
        <CardAtividade>
          <div className="card-atv-header">
            <div className="titulo">
              <div className="fundo-icon">
                <img className="atividade" src={IconModalOrcamentoAtividade} alt="Vazio" />
              </div>
              <p className="item">Item {itemData?.item}</p>
            </div>
            {!disabled && (<div onClick={() => { handleRemoveAtividade(itemData) }} className="icon-button material-icons">delete</div>)}
          </div>
          <div className="card-atv-body">
            <div className="row no-margin row-top">
              <Label title="Titulo da Atividade * " className="col s12 m8 l10">
                <Input
                  placeholder="Titulo da Atividade"
                  name="tituloAtividadeAt"
                  required="true"
                  {...{ ...(disabled ? { disabled } : {}) }}
                  value={itemData?.titulo}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].titulo = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Hora Total * " className="col s12 m4 l2">
                <Input
                  type="number"
                  name="horaTotalAt"
                  min="1"
                  required="true"
                  value={itemData?.horaTotal}
                  {...{ ...(disabled ? { disabled } : {}) }}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horaTotal = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <div className="col s12 m12 l12">
                <TextArea
                  placeholder="Descrição da Atividade"
                  name="descricaoAtividadeAt"
                  value={itemData?.descricao}
                  {...{ ...(disabled ? { disabled } : {}) }}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].descricao = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
            </div>
            {gerarProjeto && (
              <div className="row no-margin geraProjeto">
                <div className="col s12 m12 l12 no-padding">
                  <Label title="Analista " className="col s4 m4 l4">
                    <Select
                      isString
                      list={{ list: analistas, value: "id", label: "nome" }}
                      name="idAnalista"
                      firstOption
                      {...{ ...(disabled ? { disabled } : {}) }}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setAtividades((prev) => {
                          let newPrev = [...prev];

                          newPrev[index].analistas = [parseInt(v)];

                          return newPrev;
                        });
                      }}
                    />
                  </Label>
                  <Label title="Data Inicio " className="col s4 m4 l4">
                    <Input
                      type="date"
                      name="dataInicioProjeto"
                      {...{ ...(disabled ? { disabled } : {}) }}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setAtividades((prev) => {
                          let newPrev = [...prev];

                          newPrev[index].dataInicioProjeto = v;

                          return newPrev;
                        });
                      }}
                    />
                  </Label>
                  <Label title="Data Prev Entrega " className="col s4 m4 l4">
                    <Input
                      type="date"
                      name="dataPrevEntregaProjeto"
                      {...{ ...(disabled ? { disabled } : {}) }}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setAtividades((prev) => {
                          let newPrev = [...prev];

                          newPrev[index].dataPrevEntregaProjeto = v;

                          return newPrev;
                        });
                      }}
                    />
                  </Label>
                </div>
              </div>
            )}
          </div>
        </CardAtividade>
      ))}
    </Container>
  );
}

export default AtividadesList;
